<template>
  <div>
    <PCNavbar selectIndex="6-1"/>
    <MobileNavBar :currentActive="5" />
    <router-view></router-view>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import PCNavbar from "@/components/navbar/index";
import MobileNavBar from "@/components/navbar/MobileNavBar.vue";
import CallMe from "@/components/callme/index";
import MobileCallme from "@/components/callme/MobileCallme.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
};
</script>

<style>
</style>